var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkoutScheduling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b9776e70-0791-45c1-ad57-8cbf7c1ed71f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .bbfca4d4-1c18-404a-8804-d998076a2503 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "bbfca4d4-1c18-404a-8804-d998076a2503",
    cx: 50,
    cy: 13.09,
    r: 2.999
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbfca4d4-1c18-404a-8804-d998076a2503",
    d: "M68.649,14.088c.488-.616.5-1.931-.179-1.846a106.89,106.89,0,0,1-13.709,4.983c-1.505.387-2.8-.021-4.761-.021s-3.256.408-4.761.021A106.89,106.89,0,0,1,31.53,12.242c-.68-.085-.667,1.23-.179,1.846.768.968,12.769,5.19,14.631,7.3.265.3.554,6.232.344,8.6-.064.718-8.652,18.409-8.6,19.318s2.414.692,3.005.037c1.131-1.253,6.95-16.725,9.26-16.725l.012,0,.012,0c2.31,0,8.129,15.472,9.26,16.725.591.655,2.956.861,3.005-.037s-8.539-18.6-8.6-19.318c-.21-2.371.079-8.3.344-8.6C55.88,19.278,67.881,15.056,68.649,14.088Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutScheduling);
export default __webpack_public_path__ + "static/media/WorkoutScheduling.bbdbfae3c5b647ec3d41d909949c15ff.svg";
export { ForwardRef as ReactComponent };